import React from 'react';
import { useTranslation } from 'react-i18next';
import PGSolutionWorkflow from './PGSolutionWorkflow';
import ProductDetailLayout from './ProductDetailLayout';
import { getProduct } from '../../product-catalog/productPresentation';

const supportedMachines = ['XD10', 'XD20Ⅲ', 'XD26Ⅲ', 'XD38Ⅲ', 'XD42Ⅲ', 'XE20', 'XE26', 'XM20'];

export default function PGSolutionIntroPage() {
  const { t } = useTranslation('app');
  return (
    <ProductDetailLayout product={getProduct('pg-solution')}>
      <PGSolutionWorkflow />
      <section className="hicps-support-section">
        <div className="hicps-container">
          <div className="hicps-support-card">
            <div className="hicps-support-title"><h2>{t('productIntro.pgSolution.support.title')}</h2></div>
            <div className="hicps-support-description">
              <p>{t('productIntro.pgSolution.support.description')}</p>
              <div className="pg-solution-machine-list">
                {supportedMachines.map(machine => <span key={machine}>{machine}</span>)}
              </div>
              <div className="hicps-notice" />
            </div>
          </div>
        </div>
      </section>
    </ProductDetailLayout>
  );
}
